<template>
  <div>
    <div class="tabs-wrapper con">
      <div class="tabs-nav">
        <div :class="['nav-item', labelItem.mark === activeName ? 'active-nav-item' : '']" v-for="labelItem in label"
          :key="labelItem.mark" @click="clickNavHandler(labelItem.mark)">
          <img :src="labelItem.labelCover" :alt="labelItem.labelName">
          <span>{{labelItem.labelName}}</span>
        </div>
      </div>
      <div class="tabs-content">
        <div class="content-item" v-for="{label, mark, header, data} in content" :key="mark"
          v-show="mark === activeName">
          <div class="item-title">{{label}}</div>
          <div class="item-table">
            <el-table :data="data" border height="700">
              <el-table-column align="center" v-for="(value, key) in header" :key="key" :prop="key" :label="value.label"
                :width="value.width" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <div class="cons">
      <div class="tabs-content">
        <div class="content-item" v-for="{label, mark, header, data} in content" :key="mark">
          <div class="item-title">{{label}}</div>
          <div class="item-table">
            <el-table :data="data" border>
              <el-table-column align="center" v-for="(value, key) in header" :key="key" :prop="key" :label="value.label"
                :width="value.width" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 需传入的数据结构
interface LabelItem {
  mark: string //标识，与content中的mark对应
  labelName: string //nav名字
  labelCover: string //nav图片 需要写入在static文件夹中
}

type HeaderItem = string | {
  label: string //表头名字
  width?: string //表格宽度
}

interface ContentItem {
  mark: string //标识，与label中的mark对应
  label: string //sub-label名字
  header: Record<string, HeaderItem> //表头信息 需要与data的key保持一致
  data: Record<string, string | null | undefined>[] //所需要的数据，此对象的key需要与header中key保持一致
}

interface TableInfo {
  label: LabelItem[]
  content: ContentItem[]
}
 */
import { TYPE_INFO_TABLE_DETAIL } from '../constants' //TYPE_INFO_TABLE_DETAIL :TableInfo
import '@/assets/service.css'
export default {
  data() {
    console.log(typeof TYPE_INFO_TABLE_DETAIL.label, 66666666)
    const { label, content } = TYPE_INFO_TABLE_DETAIL
    const [defaultLabelItem] = label
    this.label = label
    this.content = content.map(item => {
      const obj = {}
      Object.entries(item.header).forEach(([key, value]) => {
        if (Object.prototype.toString.call(value) === '[object Object]' && typeof value.width === 'string') {
          obj[key] = value
        } else {
          obj[key] = {
            label: value,
            width: ''
          }
        }
      })
      return {
        ...item,
        header: obj
      }
    })
    return {
      activeName: defaultLabelItem.mark
    }
  },
  methods: {
    clickNavHandler(mark) {
      this.activeName = mark
    }
  }
}
</script>

<style lang="scss" scoped>
.cons {
  display: none;
  .item-title {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 10px;
  }
}
.tabs-wrapper {
  display: flex;
  .tabs-nav {
    color: #014492;
    font-size: 18px;
    font-weight: bold;
    .nav-item {
      width: 210px;
      height: 210px;
      background-color: #f4faff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      &.active-nav-item {
        background-color: #fff;
        border: 2px solid #e4e6ea;
        &::after {
          content: '';
          width: 40px;
          height: 206px;
          background-color: #fff;
          right: -4px;
          position: absolute;
        }
      }
    }
  }
  .tabs-content {
    width: 100%;
    height: 800px;
    border: 2px solid #e4e6ea;
    overflow: hidden;
    .content-item {
      padding: 30px 45px;
      .item-title {
        font-size: 16px;
        font-weight: bold;
      }
      .item-table {
        margin-top: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/products/child-components/the-type-info-table.vue